import React, { useState, useEffect } from "react";
import { Box, FormHelperText } from "@mui/material";
import { PATTER_ALPH } from "../../utils/constants";
import { Row, Col, Button, Container, Form } from "react-bootstrap";
import {
  apiGetTypeDocuments,
  apiGetFindReasoncontact,
  apiSendContactUsForm,
  apiSendSofttekForm,
  apiGetFindUbigeoDep,
  apiPostFindUbigeo,
} from "../../service/apiEndPoint";
import { SurgirTextField } from "../../components/ui/SurgirTextField/SurgirTextField";
import SurgirDropDown from "../../components/ui/SurgirDropDown/SurgirDropDown";
import SurgirAutocomplete from "../../components/ui/SurgirAutocomplete/SurgirAutocomplete";
import ReCAPTCHA from "react-google-recaptcha";
import bannerContact from '../../assets/images/contact/Imagen banner  contact.png'
import "./Contact.scss";
import {
  validateFieldString,
  validateDocumentNumber,
  validateFieldObject,
  validateEmail,
  validateForm,
} from "../../utils/ValidateField";
import ModalSuccess from "./ModalSuccess";
import ToastError from "./ToastError";
import { useSearchParams } from "react-router-dom";
import { SurgirTextArea } from "components/ui/SurgirTextArea/SurgirTextArea";
// Eliminada lógica de credenciales y URLs de Softtek. Ahora se usará apiSendSofttekForm.
//termina aquí softtek


interface DocumentType {
  codeTypeDoc: string
  documentType: string
}
interface ListDepartment {
  codeDep: string
  departament: string
}
interface FindReason {
  _id: string
  reasons: string
}

const Contact: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [typeDocument, setTypeDocument] = useState<{ value: string; name: string } | null | undefined>(null);
  const [document, setDocument] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [otherPhone] = useState("");
  const [email, setEmail] = useState("");
  const [department, setDepartment] = useState<{ value: string; name: string } | null>(null);
  const [province, setProvince] = useState<{ value: string; name: string } | null>(null);
  const [district, setDistrict] = useState<{ value: string; name: string } | null>(null);
  const [queryType, setQueryType] = useState<{ value: string; name: string } | null>(null);
  const [message, setMessage] = useState("");
  const [listDocumentType, setListDocumentType] = useState<{ value: string; name: string }[]>([]);
  const [listDepartment, setListDepartment] = useState<{ value: string; name: string }[]>([]);
  const [listProvince, setListProvince] = useState<{ value: string; name: string }[]>([]);
  const [listDistrict, setListDistrict] = useState<{ value: string; name: string }[]>([]);
  const [findReasoncontact, setFindReasoncontact] = useState<{ value: string; name: string }[]>([]);
  const [visibleModalSuccess, setVisibleModalSuccess] = useState(false);
  const [visibleModalToastSuccess, setVisibleModalToastSuccess] = useState(false);
  const [visibleValidation, setVisibleValidation] = useState(false);
  const [visibleValidationProvincia, setVisibleValidationProvincia] = useState(false);
  const [visibleValidationDistrito, setVisibleValidationDistrito] = useState(false);
  const [visibleValidationDocumento, setVisibleValidationDocumento] = useState(false); // eslint-disable-next-line no-unused-vars
  const [showErrorDocumento, setShowErrorDocumento] = useState(false); // eslint-disable-next-line no-unused-vars
  const [typeInput, setTypeInput] = useState("number"); // eslint-disable-next-line no-unused-vars
  const [messageErrorToas, setMessageErrorToast] = useState<string[]>([]);
  const [showReturnSimulator, setShowReturnSimulator] = useState(false);
  const [captchaRef, setCaptcha] = useState<string | null>(null);

  const getDisplayStyleContact = () => {
    return visibleValidation ? "inherit" : "none";


  };
  const [utmSource, setUtmSource] = useState<string | null>(null);

  useEffect(() => {

    const utm = searchParams.get("utm_source");
    if (utm) {
      setUtmSource(utm)
    }
    apiGetTypeDocuments({ codeForm: 'ContactUs' })
      .then((response) => response.json())
      .then((data) =>
        setListDocumentType(
          data.data.map((item: DocumentType) => ({
            value: item.codeTypeDoc,
            name: item.documentType,
          }))
        )
      )
      .catch((err) => console.log(err));
    apiGetFindUbigeoDep()
      .then((response) => response.json())
      .then((data) =>
        setListDepartment(
          data.result.map((item: ListDepartment) => ({
            value: item.codeDep,
            name: item.departament,
          }))
        )
      )
      .catch((err) => console.log(err));
    apiGetFindReasoncontact()
      .then((response) => response.json())
      .then((data) =>
        setFindReasoncontact(
          data.data.map((item: FindReason) => ({
            value: item._id,
            name: item.reasons,
          }))
        )
      )
      .catch((err) => console.log(err));

    if (
      searchParams.get("product") !== undefined &&
      searchParams.get("product") !== null &&
      searchParams.get("product") !== ""
    ) {
      if (searchParams.get("product") === "Crédito Mujeres Unidas") {
        setQueryType({ value: "02", name: "Solicita el Crédito Mujeres Unidas" });
        setShowReturnSimulator(true);
      }
      if (searchParams.get("product") === "Crédito Prospera") {
        setQueryType({ value: "03", name: "Solicita el Crédito Prospera" });
        setShowReturnSimulator(true);
      }
      if (searchParams.get("product") === "Crédito Construyendo Sueños") {
        setQueryType({ value: "02", name: "Solicita el Crédito Construyendo Sueños" });
        setShowReturnSimulator(true);
      }
    }

    return () => {
      console.log("destroy");
    };
  }, []);

  const envioFormulario = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleModalToastSuccessClose();
    const request = {
      typeDocument: typeDocument?.name,
      document: document,
      firstName: firstName,
      lastName: lastName,
      phone: phone,
      otherPhone: otherPhone,
      email: email,
      department: department?.name,
      province: province?.name,
      district: district?.name,
      queryType: queryType?.name,
      message: utmSource ? `[utm_source=${utmSource}] ${message}` : message,
    };
    const { complete } = validateForm(request);
    if (complete /* && captchaRef */) {
      apiSendContactUsForm(request)
        .then((response) => {
          if (response.status > 300) {
            let currentMessage: string[] = [];
            currentMessage.push("Envio Fallido de la solicitud");
            handleModalToastSuccessShow();
            setMessageErrorToast(currentMessage);
          } else {
            handleModalSuccessShow();
            response.json();
          }
        })
        .catch((error) => console.log(error));

      // Imprimir los códigos seleccionados
      console.log('Departamento (código):', department?.value);
      console.log('Provincia (código):', province?.value);
      console.log('Distrito (código):', district?.value);

      // Payload de prueba para Softtek (valores fijos)
      /*    const softtekPayload = {
           CodigoTipoSolicitud: "03", // Requerimiento
           CodigoTipoDocumento: typeDocument?.value || "01",
           NumeroDocumento: document,
           Nombres: firstName,
           Apellidos: lastName,
           Celular: phone,
           Correo: email,
           Ubigeo: department?.value || "", // Solo departamento (6 dígitos)
           Mensaje_Detalle: message || "no aplica",
           Telefono: otherPhone || "0",
           CodRespuesta: "01",
           CodMotivo: "11",
           CodSubmotivo: "111",
           CodProducto: "99",
           RazonSocial: "no aplica"
         }; */
      const softtekPayload = {

        "Apellidos": "guevara",
        "Celular": "943837471",
        "CodMotivo": "12",
        "CodProducto": "99",
        "CodRespuesta": "01",
        "CodSubmotivo": "112",
        "CodigoTipoDocumento": "01",
        "CodigoTipoSolicitud": "01",
        "Correo": "vivianrsta@gmail.com",
        "Mensaje_Detalle": "11000",
        "Nombres": "vivian",
        "NumeroDocumento": "70388529",
        "RazonSocial": "no aplica",
        "Telefono": "0",
        "Ubigeo": "121212"

      };

      apiSendSofttekForm(softtekPayload)
        .then((response) => {
          console.log("Respuesta Softtek:", response);
        })
        .catch((error) => {
          console.error("Error Softtek:", error);
        });
    } else {
      let currentMessage: string[] = [];
      if (!complete) {
        currentMessage.push("Pendiente completar todos los campos correctamente.");
      }
      if (!captchaRef) {
        currentMessage.push("Pendiente completar correctamente la verificación.");
      }
      setVisibleValidation(true);
      handleModalToastSuccessShow();
      setMessageErrorToast(currentMessage);
    }
  };



  const handleTypeDocument = (e: { value: string; name: string }) => {
    setVisibleValidationDocumento(true);
    setShowErrorDocumento(false);
    setTypeDocument(e);
    setDocument("");
    if (e.value === "02") {
      setTypeInput("text");
    }
    if (e.value === "01" || e.value === "03" || e.value === "04") {
      setTypeInput("number");
    }
  };

  const handleClickDocument = () => {
    if (typeDocument == null) {
      setShowErrorDocumento(true);
    }
  };

  const handleModalSuccessClose = () => {
    setVisibleModalSuccess(false);
    handleResetForm();
  };

  const handleModalToastSuccessClose = () => {
    setVisibleModalToastSuccess(false);
  };

  const handleModalSuccessShow = () => {
    setVisibleModalSuccess(true);
  };

  const handleModalToastSuccessShow = () => {
    setVisibleModalToastSuccess(true);
  };

  const handleResetForm = () => {
    setVisibleValidation(false);
    setTypeDocument(null);
    setDocument("");
    setFirstName("");
    setLastName("");
    setPhone("");
    setEmail("");
    setDepartment(null);
    setProvince(null);
    setDistrict(null);
    setQueryType(null);
    setMessage("");
    setCaptcha(null);
  };

  const onChangeDepartament = (value: { value: string; name: string }) => {
    setDepartment(value);
    setProvince(null);
    setDistrict(null);
    setListDistrict([]);

    const request = {
      codeDep: value.value,
      codeProv: "",
      codeDist: "",
    };

    apiPostFindUbigeo(request)
      .then((response) => response.json())
      .then((data) =>
        setListProvince(
          data.result.responseProvince.map((item: any) => ({
            value: item.codeProv,
            name: item.province,
          }))
        )
      )
      .catch((error) => console.log(error));

    setVisibleValidationProvincia(false);
    setVisibleValidationDistrito(false);
  };

  const onChangeProvince = (value: { value: string; name: string }) => {
    setProvince(value);
    const request = {
      codeDep: "",
      codeProv: value.value,
      codeDist: "",
    };

    apiPostFindUbigeo(request)
      .then((response) => response.json())
      .then((data) =>
        setListDistrict(
          data.result.responseDistrict.map((item: any) => ({
            value: item.codeDist,
            name: item.district,
          }))
        )
      )
      .catch((error) => console.log(error));
  };

  const onClickProvincia = () => {
    if (department === undefined || department === null) {
      setVisibleValidationProvincia(true);
    }
    setVisibleValidationDistrito(false);
  };

  const onClickDistrito = () => {
    if (province === undefined || province === null) {
      setVisibleValidationDistrito(true);
    }
  };

  const onChangeCaptcha = (val: string | null) => {
    setCaptcha(val);
  };

  return (
    <div>
      <div className="boxi-contact" >
        <Container>
          <div className="banner-container-banner" >
            <div className="banner-container-text">
              <span className="banner-text-banner">Contáctanos<br />
                <span className="banner-subText-banner">Si necesitas ayuda u orientación sobre nuestro producto, estaremos felices de poder atenderte.<br /> Llena el formulario y nos contactaremos contigo.</span>
              </span>
            </div>
            <div>
              <img className="banner-image" src={bannerContact} alt="Banner Conctáctanos" fetchPriority='high' />
            </div>
          </div>
        </Container>

      </div>
      <Container style={{ paddingTop: 20, margin: "0 auto" }}>
        <Box
          component="form"
          onSubmit={(e: any) => envioFormulario(e)}
          autoComplete="off"
        >
          <Col md={6} style={{ margin: "auto" }}>

            <span className="subtitle_form"> Datos personales</span>

            <Row>
              <Col
                md={{ span: 6, offset: 0 }}
                style={{ margin: "9px 0 8px 0" }}
              >
                <SurgirDropDown
                  hint={"Tipo de documento"}
                  dataSource={listDocumentType}
                  error={
                    visibleValidation && validateFieldObject(typeDocument).error
                  }
                  messageError={validateFieldObject(typeDocument).message}
                  value={typeDocument}
                  onChange={handleTypeDocument}
                />
              </Col>
              <Col
                md={{ span: 6, offset: 0 }}
                style={{ margin: "8px 0 8px 0" }}
              >
                <SurgirTextField
                  type=''
                  FormatCustom=''

                  prefix=''
                  value={document}
                  visibleError={visibleValidation}
                  disabled={
                    typeDocument == undefined ||
                    typeDocument == null ||
                    typeDocument.value == ""
                  }
                  dependValue={typeDocument}
                  validateError={validateDocumentNumber}
                  setValue={setDocument}
                  label="Número de documento"
                  fullWidth={true}
                  variant="filled"
                  onClick={handleClickDocument}
                  pattern={
                    typeDocument?.name == "DNI"
                      ? /^(\d{0,8})$/g
                      : /^([a-zA-Z]|\d){0,12}$/g
                  }
                />
              </Col>
              <Row>
                <Col style={{ margin: "8px 0 8px 0" }}>
                  <SurgirTextField
                    disabled={false}
                    onClick
                    dependValue={null}

                    value={firstName}
                    setValue={setFirstName}
                    visibleError={visibleValidation}
                    label="Nombres"
                    fullWidth={true}
                    variant="filled"
                    validateError={validateFieldString}
                    pattern={PATTER_ALPH}
                  />
                </Col>
              </Row>
              <Row>
                <Col style={{ margin: "8px 0 8px 0" }}>
                  <SurgirTextField
                    disabled={false}
                    onClick
                    dependValue={null}

                    value={lastName}
                    setValue={setLastName}
                    visibleError={visibleValidation}
                    label="Apellidos"
                    fullWidth={true}
                    variant="filled"
                    validateError={validateFieldString}
                    pattern={PATTER_ALPH}
                  />
                </Col>
              </Row>
              <br />
              <span className="subtitle_form"> Contacto y ubicación</span>
              <Row>
                <Col
                  md={{ span: 12, offset: 0 }}
                  style={{ margin: "8px 0 8px 0" }}
                >
                  <SurgirTextField
                    disabled={false}
                    onClick
                    dependValue={null}

                    value={phone}
                    setValue={setPhone}
                    visibleError={visibleValidation}
                    label="Celular de contacto"
                    fullWidth={true}
                    variant="filled"
                    validateError={validateFieldString}
                    pattern={/^\d{0,9}$/g}
                  />
                </Col>
              </Row>
              <Row>
                <Col style={{ margin: "8px 0 8px 0" }}>
                  <SurgirTextField
                    disabled={false}
                    onClick

                    value={email}
                    setValue={setEmail}
                    visibleError={visibleValidation}
                    label="Correo electrónico"
                    fullWidth={true}
                    variant="filled"
                    validateError={validateEmail}
                    pattern={/[^\s]/}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <SurgirAutocomplete
                    error={
                      visibleValidation && validateFieldObject(department).error
                    }
                    messageError={validateFieldObject(department).message}
                    hint={"Departamento"}
                    value={department}
                    onChange={onChangeDepartament}
                    dataSource={listDepartment}
                    required={false}
                    search={"name"}
                    idVariant={"departamento"}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <SurgirAutocomplete
                    error={
                      (visibleValidation || visibleValidationProvincia) &&
                      validateFieldObject(province).error
                    }
                    messageError={
                      visibleValidationProvincia
                        ? "Elige primero un departamento."
                        : validateFieldObject(province).message
                    }
                    hint={"Provincia"}
                    value={province}
                    onChange={(value) => {
                      onChangeProvince(value);
                      setDistrict(null);
                    }}
                    onClick={onClickProvincia}
                    dataSource={listProvince}
                    required={false}
                    search={"name"}
                    disabled={listProvince.length == 0}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <SurgirAutocomplete
                    error={
                      (visibleValidation || visibleValidationDistrito) &&
                      validateFieldObject(district).error
                    }
                    messageError={
                      visibleValidationDistrito
                        ? "Elige primero un departamento y una provincia."
                        : validateFieldObject(district).message
                    }
                    hint={"Distrito"}
                    value={district}
                    onChange={setDistrict}
                    onClick={onClickDistrito}
                    dataSource={listDistrict}
                    required={false}
                    disabled={listDistrict.length == 0}
                    search={"name"}
                  />
                </Col>
              </Row>
              <br />
              <span className="subtitle_form"> Creación de la consulta </span>
              <br />
              <Row>
                <Col style={{ margin: "8px 0 8px 0" }}>
                  <SurgirDropDown
                    hint={"Tipo de consulta"}
                    dataSource={findReasoncontact}
                    error={
                      visibleValidation && validateFieldObject(queryType).error
                    }
                    messageError={validateFieldObject(queryType).message}
                    value={queryType}
                    onChange={setQueryType}
                  />
                </Col>
              </Row>
              {
                queryType?.name == 'Dónde pago mi cuota' && (
                  <Row>
                    <Col style={{ margin: "8px 0 8px 0" }}>
                      Para realizar el pago de tu cuota <a href='https://app-fondoscolectivos-pago-test.azurewebsites.net/#/login'> clic aquí </a>
                    </Col>
                  </Row>
                )
              }

              {
                queryType?.name == 'Canales de atención' && (
                  <Row>
                    <Col style={{ margin: "8px 0 8px 0" }}>
                      Si deseas saber más acerca de nuestras zonas de cobertura <a href='/donde-estamos'> clic aquí </a>
                    </Col>
                  </Row>
                )
              }


              <Row>
                <Col sm={12} style={{ margin: "8px 0 8px 0" }}>
                  <SurgirTextArea
                    fullWidth={true}
                    value={message}
                    onChange={({ target }: any) => setMessage(target.value)}
                    label="Mensaje"
                    variant="filled"
                    error={
                      visibleValidation && validateFieldObject(message).error
                    }
                    messageError={validateFieldObject(message).message}
                    maxLength={4000}
                    isDisabled={queryType?.name === 'Dónde pago mi cuota' || queryType?.name === 'Canales de atención'}

                  />
                </Col>
              </Row>

              {/* Se eliminaron los checks de conformidad y política de datos */}
              <span className="parrafo"> Al enviar tu solicitud:<br />

                I) SANTANDER EMPRESA ADMINISTRADORA DE FONDOS COLECTIVOS S.A. es el responsable del tratamiento de tus datos y titular de los bancos de datos de “Clientes ” y “Prospectos de Clientes”

                II) Realizará el tratamiento de tus datos para dar cumplimiento a los fines necesarios que resultan de la ejecución de nuestra relación contractual y cumplimiento regulatorio.

                III) Asimismo, te informamos que, en cualquier momento, puedes ejercer cualquiera de los derechos establecidos en la ley de protección de datos personales a través del siguiente buzón privacidad@santanderffcc.com.pe

                IV) Finalmente; para mayor información ponemos a tu disposición nuestra <a
                  href="/transparencia "
                  className="linkturquesa "
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  política de privacidad
                </a>  en nuestra web.</span>
              <br />
            </Row>
           {/* <div className="w-100 d-flex justify-content-center">
              <ReCAPTCHA
                style={{ textAlign: "center" }}
                sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY ?? ''}
                onChange={onChangeCaptcha}
              />

            </div>*/}
            <center>
              <Row>
                <Col>
                  <Button
                    style={{
                      width: 180,
                      borderRadius: 32,
                      fontFamily: "SantanderTextW05-Bold",
                      fontSize: "16",
                      height: 48,
                      textAlign: "center",
                      marginTop: 30,
                      marginBottom: 50,
                    }}
                    variant="danger"
                    type="submit"
                  >
                    {" "}
                    Enviar consulta{" "}
                  </Button>


                </Col>
              </Row>



              <br />
              <br />
              <br />
              <br />
            </center>
          </Col>
        </Box>

        <ModalSuccess
          handleShow={() => { }}

          show={visibleModalSuccess}
          handleClose={handleModalSuccessClose}
          handleReset={handleResetForm}
        />
        <ToastError
          handleShow={() => { }}

          show={visibleModalToastSuccess}
          handleClose={handleModalToastSuccessClose}
          messages={messageErrorToas}
        />
      </Container>
    </div>
  );

}
export default Contact;

